import amplitude from 'amplitude-js';

let initialized = false;

export const amplitudeProvider = {
  init(apiKey) {
    if (!apiKey) {
      console.warn('[Analytics] Amplitude key missing');
      return;
    }
    amplitude.getInstance().init(apiKey, undefined, {
      includeUtm: true,
      includeGclid: true,
      includeReferrer: true,
      defaultTracking: {
        pageViews: true,
        sessions: true,
        formInteractions: true,
        fileDownloads: true,
      },
    });
    initialized = true;
  },

  track(name, data) {
    if (!initialized) return;
    amplitude.getInstance().logEvent(name, data);
  },

  identify(id, traits) {
    if (!initialized) return;
    amplitude.getInstance().setUserId(id);
    if (traits && Object.keys(traits).length) {
      amplitude.getInstance().setUserProperties(traits);
    }
  },

  isReady: () => initialized,
};
